import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import useInfoContext from "hooks/useInfoContext";
import RightSidebar from "components/RightSidebar";
import MainContent from "components/MainContent";
import Grid from "@mui/material/Grid2";
import navigationEnum from "lib/enums/navigationEnum";
import cardEnum from "lib/enums/cardEnum";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const MainLayout = () => {
  const { currentPage, setCurrentPage, showSidebar } = useInfoContext();
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (!isSmallDevice) {
      navigate(navigationEnum.EDIT_ACCOUNT.path);
    } else {
      navigate(navigationEnum.ACCOUNT.path);
    }
  }, [isSmallDevice]);

  useEffect(() => {
    const currentPath = location.pathname;
    const pathsList = { ...cardEnum, ...navigationEnum };
    const currentMenuItem = Object.values(pathsList).find(
      (item) => item.path === currentPath
    );
    setCurrentPage(currentMenuItem);
  }, [location.pathname, setCurrentPage]);

  const content = (
    <MainContent>
      <Outlet />
    </MainContent>
  );

  const sidebarContent = () => {
    if (!isSmallDevice) {
      return <RightSidebar />;
    } else if (!showSidebar) {
      return content;
    } else {
      return <RightSidebar />;
    }
  };

  return (
    <Grid container className="main-layout-wrapper" columns={12}>
      <Grid size={{ xs: 0, md: 8, lg: 9, xl: 10 }} className="content-box">
        {content}
      </Grid>
      <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }} className="right-sidebar">
        {sidebarContent()}
      </Grid>
    </Grid>
  );
};

export default MainLayout;
